import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { Business } from '../models/business.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { AirportService } from '../../airport/airport.service';
import { Tag } from '../../shared/models/tag.model';
import { TagService } from '../../shared/services/tag.service';
import { hasTag } from '../../util/tag-utils';


@Component({
  selector: 'app-edit-communication',
  templateUrl: './edit-communication.component.html',
  styleUrls: ['./edit-communication.component.scss']
})
export class EditCommunicationComponent implements OnInit {
  isLoading = true;
  business: Business;
  formGroup: FormGroup;
  monitorsCTAFTag: Tag;
  monitorsCTAF = false;

  constructor(private matDialogRef: MatDialogRef<EditCommunicationComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private businessManagerService: BusinessManagerService,
              private _airportService: AirportService,
              private _tagService: TagService,
              public snackBar: MatSnackBar) {
    this.business = data.business;
  }

  async ngOnInit() {
    this.formGroup = new FormGroup({
      arincFreq: new FormControl(this.business.arincFreq,
        [Validators.nullValidator, Validators.pattern('^[0-9]{3}\.[0-9]{1,3}$')]),
      unicomFreq: new FormControl(this.business.unicomFreq,
        [Validators.nullValidator, Validators.pattern('^[0-9]{3}\.[0-9]{1,3}$')]),
      monitoringCTAF: new FormControl(false)
    });
    this.isLoading = false;
    this.formGroup.patchValue({arincFreq: this.formatFrequency(this.business.arincFreq) || ''});
    this.formGroup.patchValue({unicomFreq: this.formatFrequency(this.business.unicomFreq) || ''});
    const allTags = await this._tagService.getAllTags();
    this.monitorsCTAFTag = await this._tagService.findTagByName(allTags, 'Monitor CTAF');
    this.monitorsCTAF = hasTag(this.business.tags, 'Monitor CTAF');

    if (this.monitorsCTAF) {
      this.formGroup.patchValue({monitoringCTAF: true});
    }
  }

  formatFrequency (frequency: string): string {
    if (frequency && Number(frequency) % 1 === 0) {
      // The frequency is an integer
      return frequency.toString() + '.0';
    } else {
      return frequency;
    }
  }

  /**
   * closes modal
   */
  close(result = {cancelBtnClicked: true, success: false}) {
    if (result) {
      this.matDialogRef.close(result);
    }
  }

  /**
   * submits form values to api server if formGroup.valid property is true
   * @return {Promise<void>}
   */
  async save() {
    const TEMP_BUSINESS = this.business;
    if (!this.formGroup.valid) {
      return;
    }

    // form values are mapped to business object before api call.
    this.business.arincFreq = this.formGroup.value.arincFreq;
    this.business.unicomFreq = this.formGroup.value.unicomFreq;

    try {
      await this.businessManagerService.updateBusiness(this.business);
      if (!this.monitorsCTAF && this.formGroup.controls.monitoringCTAF.value) {
        await this._tagService.postTag(this.monitorsCTAFTag.tagId, this.business.id);
      } else if (this.monitorsCTAF && !this.formGroup.controls.monitoringCTAF.value) {
        await this._tagService.deleteTag(this.monitorsCTAFTag.tagId, this.business.id);
      }
      this.business = await this._airportService.getBusiness(this.business.id.toString());
      this.close({cancelBtnClicked: false, success: true});
    } catch (e) {
      this.snackBar.open('Failed to save Monitoring CTAF setting', 'Error', {
        duration: 6000
      });
      this.business = TEMP_BUSINESS;
      this.close({cancelBtnClicked: false, success: false});
    }
  }
}
